import { Button } from "@aws-amplify/ui-react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

export const generatePdf = async (printRef) => {
  const pdf = new jsPDF();

  pdf.html(printRef, {
    callback: function (doc) {
      // Save the PDF
      doc.save("document-html.pdf");
    },
    margin: [10, 10, 10, 10],
    autoPaging: "text",
    x: 0,
    y: 0,
    width: 190, //target width in the PDF document
    windowWidth: 720, //window width in CSS pixels
  });
};

export const handleDownloadPdf = async (printRef, filename) => {
  generatePdf(printRef);
};

const PDFGenerator = ({ printRef, clickHandler, endClickHandler }) => {
  return (
    <Button
      variant="contained"
      color="primary"
      sx={{ marginRight: 1 }}
      onClick={() => {
        clickHandler();
        const filename = `Facts-Sheet.pdf`;
        handleDownloadPdf(printRef, filename).finally(() => endClickHandler());
      }}
    >
      Download as PDF
    </Button>
  );
};

export default PDFGenerator;
